export default "__VITE_ASSET__71d9eb00__"